// @flow
import React from 'react';
import useBookmarks from 'javascripts/hooks/useBookmarks';
import { t } from 'javascripts/utils/withTranslation';
import HeaderIcon from './HeaderIcon';
import type { ExternalProps } from '../types';

const Bookmark = ({ bookmark }: ExternalProps): React$MixedElement => {
  const [bookmarks] = useBookmarks();
  const initialFilled = bookmarks.length > 0;

  if (!bookmark) {
    return <></>;
  }

  return (
    <HeaderIcon
      link={bookmark.url}
      icon="bw-bookmark-line"
      iconFilled="bw-bookmark-solid"
      initialFilled={initialFilled}
      label={bookmark.title || t('Merkliste')}
      labelId="header-icon-label--bookmark"
      tooltip={bookmark.title || t('Merkliste')}
    />
  );
};

export default Bookmark;
